import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IResponseApi } from '@/types/apis/response';
import { apiCaller } from '../query';

export const initialState = {
  currentPage: 1,
  locales: [] as IResponseApi.ILanguage[],
  ruleInfo: [] as IResponseApi.RuleInfo[],
};

export const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    handleChangeCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    handleSetShopLocales: (state, action: PayloadAction<IResponseApi.ILanguage[]>) => {
      state.locales = action.payload;
    },
    handleSetRuleInfo: (state, action: PayloadAction<IResponseApi.RuleInfo[]>) => {
      state.ruleInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(apiCaller.endpoints.getLanguage.matchFulfilled, (state, action) => {
        state.locales = action.payload.data;
      })
      .addMatcher(apiCaller.endpoints.getRuleName.matchFulfilled, (state, action) => {
        state.ruleInfo = action.payload.rules;
      });
  },
});

export const selectCurrentPageSelector = createSelector(
  (state: RootState) => state.translation,
  (state) => state.currentPage,
);

export const selectShopLocaleSelector = createSelector(
  (state: RootState) => state.translation,
  (state) => state.locales,
);

export const selectRuleInfoSelector = createSelector(
  (state: RootState) => state.translation,
  (state) => state.ruleInfo,
);

export const { handleChangeCurrentPage, handleSetShopLocales, handleSetRuleInfo } = translationSlice.actions;
export default translationSlice;
